import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.SET_QUESTION_MODEL_STATISTICS_ID]: isEnding,
  [types.QUESTION_MODEL_STATISTICS_COUNT]: isLoading,
  [types.QUESTION_MODEL_STATISTICS_COUNT_SUCCESS]: isEnding,
  [types.QUESTION_MODEL_STATISTICS_COUNT_FAILURE]: isEnding,
  [types.CLEAR_QUESTION_MODEL_STATISTIC]: isEnding,
});
